<script setup lang="ts">
import type { ChipColor } from '@/components/base/BaseChip.vue'

const props = defineProps<{
  index: number
  title: string
  value: number
  trend: string | number
  active: boolean
}>()

const { formatNumber } = useNumber()

const emit = defineEmits<{
  (e: 'click', index: number): void
}>()

const getColor = computed<ChipColor>(() => {
  const trendNumber = Number(props.trend)
  let color: ChipColor = 'slate'

  if (trendNumber === 0) {
    color = 'slate'
  } else if (trendNumber > 0) {
    color = 'green'
  } else {
    color = 'red'
  }

  return color
})
</script>

<template>
  <div
    class="cursor-pointer border-t-8 p-6 px-10 transition"
    :class="active ? 'bg-muted border-primary' : 'border-white hover:bg-accent hover:border-border'"
    @click="emit('click', index)"
  >
    <h3 class="text-lg text-foreground">{{ title }}</h3>
    <div class="flex flex-row items-center gap-4 lg:flex-col lg:items-start lg:gap-0">
      <p class="my-1 text-4xl font-bold text-primary">
        {{ formatNumber(value) }}
      </p>
      <BaseChip
        :text="trend.toString()"
        :color="getColor"
        :icon="Number(trend) < 0 ? 'HeroArrowLongDownIconOutline' : 'HeroArrowLongUpIconOutline'"
      />
    </div>
  </div>
</template>
